import { render, staticRenderFns } from "./PenNameSaveDialog.vue?vue&type=template&id=8c6b9856&scoped=true"
import script from "./PenNameSaveDialog.vue?vue&type=script&lang=ts"
export * from "./PenNameSaveDialog.vue?vue&type=script&lang=ts"
import style0 from "./PenNameSaveDialog.vue?vue&type=style&index=0&id=8c6b9856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6b9856",
  null
  
)

export default component.exports